define([
	"dojo/_base/declare",
	"underscore",
	"csi",
	"csi/table/matrix/ColumnAssociation",
	"csi/xml/Query",
	"csi/xml/QueryProcessor",
], function(declare, _, csi, ColumnAssociation, Query, QueryProcessor) {

	var isNullArray = function(arr) {
		for (var i = 0; i < arr.length; i++) {
			if (arr[i] != null) {
				return false;
			}
		}
		return true;
	}

	return declare(ColumnAssociation, {
		bAllowOnRootNode: true,
		columnAssociation: "PlanSecondary",
		columnPath: "Child:Secondaries",
		SECONDARY_FILTER_LEVEL: "1",

		/**
		 * Add path to get PlanSecondary of each column node to sort and filter below
		 */
		addDependencyPaths: function(h, paths) {
			paths.push("Child:Secondaries/Child:PlanSecondary;Up;Down");
			this.inherited(arguments);
		},

		/**
		 * Return an array of nodes based on switchboard selections 
		 * @return {Array} - an Array of the column nodes to display
		 */
		_getColumnNodes: function(ctx, h) {
			var filteredNodes;
			var secondaries = ctx.view.activeMerchSecondaries;
			var secondaryNodes = ctx.cache.getNodes(secondaries);

			// As per C8-16643 Secondaries can be None in case of TYPE_COLUMN
			if (secondaries == null || isNullArray(secondaryNodes)) {
				// In case of ShowAllSecondaries boolean on plan is true then set secondaryNodes to all secondaries
				const view = ctx.view;
				const node = view.getViewNode();
				const cache = view.cacheView;
				const level = node && cache.get(node.__Parent__);
				const plan = level && cache.get(level.Plan);
				if (plan && plan.ShowAllSecondaries) {
					secondaryNodes = this.inherited(arguments);
				} else {
					return [];
				}
			}

			// filter nodes that match the urlSecondaryType
			filteredNodes = !isNullArray(secondaryNodes) && _.filter(secondaryNodes, function(version) {
				const planSecondary = version && ctx.cache.getNode(version.PlanSecondary);
				return planSecondary && (planSecondary.Subtype == ctx.view.get("urlSecondaryType"));
			});

			// sort by name
			filteredNodes = !isNullArray(filteredNodes) && csi.sort(filteredNodes, function(version) {
				return version && ctx.cache.getNode(version.PlanSecondary).$Name;
			});

			// also filter by custom view filter if there is one
			var ql = ctx.view.getQueryLevel(this.SECONDARY_FILTER_LEVEL);
			var qlf = ctx.view.getQueryLevelFilter(ql);
			if (qlf) {
				var queryObject = qlf.toQuery(new Query());
				if (queryObject) {
					filteredNodes = QueryProcessor.applyQueryToNodes(queryObject, filteredNodes, ctx.cache);
				}
				// get the planSecondary of each of the filtered nodes
				filteredNodes = _.map(filteredNodes, function(obj) {
					return obj && ctx.cache.getNode(obj.PlanSecondary);
				});
			}

			return filteredNodes;
		}

	});
});